import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useResultsChartsDataContext } from './hooks/useResultsChartsDataContext';

export const MonthlyLiveBirths = () => {
    const { chartData } = useResultsChartsDataContext();


    return (
        <SimpleBars
            title={'Evolução Mensal dos Nascidos Vivos'}
            horizontal={false}
            subtitles={chartData?.monthlyLiveBirths?.map((item) => item.description)}
            values={chartData?.monthlyLiveBirths?.map((item) => item.total  ||  0)}
        />
    );
};
